var map = {
	"./house-icon.png": 79840,
	"./left-arrow-icon.png": 58087,
	"./logout-icon.png": 23736,
	"./right-arrow-icon.png": 19326,
	"./tools-icon.png": 28555,
	"./warning-icon.png": 15072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76088;